import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { Button, Tooltip } from '@mui/material';
import {
  showReleaseRescueButton,
  showUnAdoptRescueButton,
  showUnClaimRescueButtons,
} from '../../helpers/RescuesHelper';
import useRescuerRescueActions from '../../hooks/useRescuerRescueActions';
import ConfirmationDialog from '../ConfirmationDialog';
import useActiveUser from '../../hooks/useActiveUser';

const customActionsButtonsSx = {
  margin: '6px',
  fontSize: 11,
  padding: '6px',
};

const ReleaseRescueDesktopButtons = ({ rescue }) => {
  const { releaseRescue, rescueUnclaim, rescueUnadopt } = useRescuerRescueActions();
  const rescuer = useActiveUser();

  const handleOnUnClaimClick = () =>
    confirmAlert({
      title: 'Are you sure?',
      buttons: [
        {
          variant: 'outlined',
          label: 'Never mind',
          color: 'primary',
          size: 'small',
          onClick: () => {},
        },
        {
          variant: 'contained',
          label: 'Release',
          color: 'primary',
          size: 'small',
          onClick: () => rescueUnclaim(rescue),
        },
      ],
      message: 'Releasing this rescue may result in this food going to waste, but we understand that life happens!',
      customUI: ({ title, message, onClose, buttons }) => (
        <ConfirmationDialog
          buttons={buttons}
          closeDialog={onClose}
          title={title}
          message={message}
        />
      ),
    });

  const handleUnadopt = () =>
    confirmAlert({
      title: 'Are you sure?',
      buttons: [
        {
          variant: 'outlined',
          label: 'Never mind',
          color: 'primary',
          size: 'small',
          onClick: () => {},
        },
        {
          variant: 'contained',
          label: 'Unadopt',
          color: 'primary',
          size: 'small',
          onClick: () => rescueUnadopt(rescue),
        },
      ],
      message: 'Unadopting this rescue will release all rescues from this adoption. Do you want to continue?',
      customUI: ({ title, message, onClose, buttons }) => (
        <ConfirmationDialog
          buttons={buttons}
          closeDialog={onClose}
          title={title}
          message={message}
        />
      ),
    });

  const handleReleaseClick = () =>
    confirmAlert({
      title: 'Are you sure?',
      buttons: [
        {
          variant: 'outlined',
          label: 'Never mind',
          color: 'primary',
          size: 'small',
          onClick: () => {},
        },
        {
          variant: 'contained',
          label: 'Release',
          color: 'primary',
          size: 'small',
          onClick: () => releaseRescue(rescue),
        },
      ],
      message: 'Releasing this rescue may result in this food going to waste, but we understand that life happens!',
      customUI: ({ title, message, onClose, buttons }) => (
        <ConfirmationDialog
          buttons={buttons}
          closeDialog={onClose}
          title={title}
          message={message}
        />
      ),
    });

  return (
    <>
      {showUnClaimRescueButtons(rescue, rescuer) && (
        <Tooltip
          arrow
          placement="top"
          key="Release Rescue"
          title="Release Rescue"
          sx={customActionsButtonsSx}
        >
          <Button
            type="button"
            variant="contained"
            color="primary"
            size="small"
            onClick={handleOnUnClaimClick}
          >
            Release Rescue
          </Button>
        </Tooltip>
      )}

      {showReleaseRescueButton(rescue, rescuer) && (
        <Tooltip
          arrow
          placement="top"
          key="Release Rescue"
          title="Release Rescue"
          sx={customActionsButtonsSx}
        >
          <Button
            type="button"
            variant="contained"
            color="primary"
            size="small"
            onClick={handleReleaseClick}
          >
            Release Rescue
          </Button>
        </Tooltip>
      )}

      {showUnAdoptRescueButton(rescue, rescuer) && (
        <Tooltip
          arrow
          placement="top"
          key="Unadopt"
          title="Unadopt"
          sx={customActionsButtonsSx}
        >
          <Button type="button" variant="contained" color="primary" size="small" onClick={handleUnadopt}>
            Unadopt
          </Button>
        </Tooltip>
      )}
    </>
  );
};

export default ReleaseRescueDesktopButtons;
